<template>
  <v-app id="photos">
    <v-app-bar app dark dense color="primary">
      <v-toolbar-title>Censo MKD</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>Id Actividad: {{ idactividad }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-card class="elevation-5">
          <v-card-text v-for="(item, i) in fotos" :key="i">
            <v-row align="center" justify="center">
              <img :src="item" style="width:100%;max-width:600px;"/>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ message }}
      </v-snackbar>
    </v-content>
    <v-footer app>
    </v-footer>
  </v-app>
</template>

<script>
import services from '@/utils/services'

export default {
  name: 'photosActivity',
  data: () => ({
    loading: false,
    error: false,
    message: '',
    idactividad: '',
    fotos: []
  }),
  mounted () {
    this.idactividad = this.$route.query.id
    this.getPhotos()
  },
  methods: {
    getPhotos() {
      this.loading = true
      setTimeout(() => {
        let params = {
          id: this.idactividad
        }
        this.axios.get(services.routes.photosActivity, { params })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              this.fotos = res.data.fotos
            } else {
              this.error = true
              this.message = res.mensaje
            }
          })
          .catch(error => {
            console.log(error)
            this.error = true
            this.message = 'El servicio no se encuentra disponible en estos momentos'
          })
          .finally(() => {
            this.loading = false
          })
      }, 300)
    }
  }
}
</script>
